import { Tooltip, Typography } from "@mui/material";

export const StoreItemsMovementColumns = [
  {
    field: "item_name",
    headerName: "Item Name",
    flex: 1.5,
    renderCell: (params) => {
      return (
        <Tooltip title={params.row.item_name}>
          <Typography color="initial">{params.row.item_name}</Typography>
        </Tooltip>
      );
    },
  },
  {
    field: "total_in",
    headerName: "Total In",
    flex: 0.8,
    renderCell: (params) => {
      return (
        <Typography color="success.main">
          {params.row.total_in}
        </Typography>
      );
    },
  },
  {
    field: "total_out",
    headerName: "Total Out",
    flex: 0.8,
    renderCell: (params) => {
      return (
        <Typography color="error.main">
          {params.row.total_out}
        </Typography>
      );
    },
  },
  {
    field: "balance",
    headerName: "Balance",
    flex: 0.8,
    renderCell: (params) => {
      return (
        <Typography
          color={params.row.balance > 0 ? "primary.main" : "error.main"}
        >
          {params.row.balance}
        </Typography>
      );
    },
  },
]; 